module.exports = __webpack_public_path__ + "img/fa02.40a3753d.jpg";